import * as React from 'react';

import { EFieldName } from '../../../../types/field';
import { TABLE_PHOTOS_TITLE } from '../../../../constants/table';
import { CommonRowTitleContainer } from './common/CommonRowTitle';

export const HeaderRowTitleContainer: React.FC = () => (
  <CommonRowTitleContainer name={EFieldName.Photos} title={TABLE_PHOTOS_TITLE} />
);
